"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.normalize = normalize;
var _isArray = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/array/is-array"));
var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/for-each"));
var _indexOf = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/index-of"));
/**
 * Normalizes an array of objects
 * @param  {array}  collection | an array of objects, where each object contains an ID-like property
 * @param  {string} [customId] | optional string to use in place of 'id' property
 * @return {object}            | normalized data object with 'allIds' and 'byId' properties
 */
function normalize(collection, customId) {
  if (!(0, _isArray.default)(collection)) {
    throw new Error(`Collection must be of type 'array'. Got ${typeof collection} instead.`);
  }
  if (!collection.length) {
    throw new Error('Collection is empty.');
  }
  const allIds = [];
  const byId = {};
  const idToUse = customId || 'id';
  (0, _forEach.default)(collection).call(collection, item => {
    if (!item[idToUse]) {
      throw new Error(`Each item in the collection must have an 'id' property or a custom ID property indicated.`);
    }
    if ((0, _indexOf.default)(allIds).call(allIds, item[idToUse]) !== -1) {
      throw new Error('Each item in the collection must have a unique id.');
    }
    allIds.push(item[idToUse]);
    byId[item[idToUse]] = item;
  });
  return {
    byId,
    allIds
  };
}